import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './calcom-integration-tab-skeleton.scss';

const SECTION_COUNT: number = 2;

const CalcomIntegrationTabSkeleton = () => (
  <div className="calcom-integration-tab-skeleton" aria-hidden>
    <div className="outer-card">
      <div className="group">
        <Skeleton variant="text" width="16rem" />
        <Skeleton variant="text" width="28rem" />
        <Skeleton variant="rect" width="16rem" height="4rem" />
      </div>

      {Array.from({ length: SECTION_COUNT }, (_, index: number) => (
        <div key={`calcom-section-skeleton-${index}`} className="group">
          <Skeleton variant="text" width="20rem" />
          <Skeleton variant="text" width="32rem" />
          <Skeleton variant="rect" width="14rem" height="3.6rem" />
        </div>
      ))}
    </div>
  </div>
);

export default CalcomIntegrationTabSkeleton;